<div 
  class="phx-comment-field-container" 
  [ngClass]="{
    'phx-comment-field-disabled': phxDisabled,
    'phx-comment-field-focused': isFocused,
    'phx-comment-field-has-error': phxError
  }"
>
  <textarea
    class="phx-comment-field-textarea"
    [placeholder]="phxPlaceholder || ('Write something...' | phxTranslate)"
    [value]="_value"
    [disabled]="phxDisabled"
    (input)="onTextareaInput($event)"
    (keydown)="onKeydown($event)"
  ></textarea>
  <div class="phx-comment-field-actions">
    <ng-container *ngIf="isEditMode && !phxDisabled">
      <span class="phx-comment-field-actions-text">{{ 'Esc to' | phxTranslate}}</span>
      <span class="phx-comment-field-action" (click)="onCancel()">{{ 'Cancel' | phxTranslate }}</span>
    </ng-container>
    <ng-container *ngIf="hasValueChanged">
      <i *ngIf="isEditMode" phx-icon [phxIcon]="Bullet16Icon" [size]="16"></i>
      <span class="phx-comment-field-actions-text">
        {{ 'Enter' | phxTranslate }}
        <i phx-icon [phxIcon]="EnterIcon" [size]="16"></i>
        {{ 'to' | phxTranslate }}
      </span>
      <span class="phx-comment-field-action" (click)="onSave()">{{ 'Save' | phxTranslate }}</span>
    </ng-container>
  </div>
  <div *ngIf="phxCheckboxLabels?.length" class="phx-comment-field-extras">
    <phx-divider></phx-divider>
    <phx-checkbox
      *ngFor="let label of phxCheckboxLabels"
      (phxCheckedChange)="onCheckboxChange(label, $event)"
    >{{ label }}</phx-checkbox>
  </div>
</div>
<div *ngIf="phxError" class="phx-comment-field-error">{{ phxError }}</div>
<div *ngIf="phxSubtext && !phxError" class="phx-comment-field-subtext">{{ phxSubtext }}</div>